import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=589ea6d8&scoped=true&"
var script = {}
import style0 from "./Pagination.vue?vue&type=style&index=0&id=589ea6d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ea6d8",
  null
  
)

export default component.exports